import React, { useState } from "react";
import "./EditProfileEmail.css";

const EditProfileEmail = (props) => {
  const [email, setEmail] = useState('');

  const onInputChange = (event) => {
    const emailValue = event.target.value
    setEmail(emailValue);
    props.getEmailData(emailValue);
  }

  const onSubmit = (event) => {
    event.preventDefault();

  }

  return (
    <div className="edit-profile-email">
      <div className="first-name-h-eading">
        <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Email</div>
      </div>
      <input 
        onSubmit={onSubmit}
        className="email-input-field border-1px-mischka"
        type="text" 
        value={email}
        onChange={onInputChange} 
      />
    </div>
  );
}

export default EditProfileEmail;
